<script>
    import {durations} from './constants';

    if (!localStorage.currentDuration) {
        localStorage.currentDuration = durations[0];
    }
    let currentDuration = localStorage.currentDuration;

    /**
     * Save current duration and go back to home page
     */
    const onDurationChangedHandler = () => {
        currentDuration = event.currentTarget.value;
        localStorage.currentDuration = currentDuration;
        history.back();
    }
</script>

<style>
    label{
        cursor: pointer;
    }
</style>

<main class="text-white p-5 text-center">
    {#each durations as duration}
        {#if currentDuration == duration}
            <label class="m-2 py-2 px-3 bg-success text-light rounded">{duration}
            min<input type="checkbox" value={duration} class="d-none" checked on:change={onDurationChangedHandler}/></label>
        {:else}
            <label class="m-2 py-2 px-3 bg-light text-dark rounded">{duration}
                min<input type="checkbox" value={duration} class="d-none" on:change={onDurationChangedHandler}/></label>
        {/if}
    {/each}
</main>
